import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'
import BarGraphs from '../../components/Charts/BarGraphs'
import PieChart from '../../components/Charts/PieChart'
import Select from 'react-select'

import HomeLarge from '../../components/HomeLarge';
import HomeMini from '../../components/HomeMini';
import axiosConfig from '../../config/axiosConfig'

import GroupVRNSelect from '../../containers/comps/GroupVRNSelectContainer'
import BasicTable from '../../components/Tables/BasicTable'


const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'black' : 'black',
        backgroundColor: state.isSelected ? 'yellow' : 'white',

    }),
    control: (provided) => ({
        ...provided,
        borderRadius: '50px',
        borderColor: 'Yellow',
    })
}


function Iframe(props) {
    console.log("URL Calling : ", props.src)
    return (
        <div>
            <iframe src={props.src} height={props.height} width={props.width} allowFullScreen={true} style={{ border: 0 }} />
        </div>
    )
}



const firstDate = new Date();
const currentDate = new Date();

class FleetOverViewDashboardSummary extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fodata: {},

            firstDay: new Date(firstDate.getFullYear(), firstDate.getMonth(), 1),
            fromDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 2).toISOString().substring(0, 10), //new Date(date.getFullYear(), date.getMonth(), 1);
            toDate: new Date().toISOString().substring(0, 10),

            HSSETabOption: 1,
            HSSETabGroup: 0,
            HSSETabVehicle: 0,
            HSSEBarOption: 1,
            HSSEBarGroup: 0,
            HSSEBarVehicle: 0,
            HSSEPieOption: 1,
            HSSEPieGroup: 0,
            HSSEPieVehicle: 0,
            TimeFrameId: 'three_month',

            srcURL_Shell_Card_Transaction_Value_In_Litre_Pie: '',
            srcURL_Shell_Card_Transaction_Value_In_PKR_Pie: '',
            srcURL_Total_KMs_Travelled_Pie: '',
            srcURL_Total_Driven_Hours_Pie: '',
            srcURL_Average_Shell_Card_Mileage_Pie: '',

            srcURL_Shell_Card_Transaction_Value_In_Litre_bar: '',
            srcURL_Shell_Card_Transaction_Value_In_PKR_bar: '',
            srcURL_Total_KMs_Travelled_bar: '',
            srcURL_Total_Driven_Hours_bar: '',
            srcURL_Average_Shell_Card_Mileage_bar: '',

            srcURL_FleetBulletin: '',

        };



    }

    getFOData() {

        axiosConfig.post('Portal/GetFleetOverView', {
            "UserAccountBranchID": localStorage.getItem('selectedBranch'),
            "SearchTypeId": 1,
            "CardMappingMasterId": 0,
            "VRNGroupMasterId": 0,
            "StartTime": this.state.fromDate,
            "EndTime": this.state.toDate,
        })
            .then((res) => {
                this.setState({ fodata: res.data.fleetOverView[0] })
            })
            .catch(console.error)
            .finally(() => {

            });
    }


    componentDidMount() {
        this.getFOData();
    }
    render() {

        return (

            <div>
                <Container>
                    <Row>
                        <Card style={{ width: '100%', height: '50px' }}>
                            <Card.Body>
                                <a href="./MyReports" style={{ color: 'blue' }}>
                                    <p>For more details on your fleet’s performance, click here to visit My Reports</p>
                                </a>
                            </Card.Body>
                        </Card>

                    </Row>

                    <Row>

                    <Col className="col-md-12">

                        <CardDeck>
                            <HomeLarge Title="Fleet Overview" Icon="fa fa-truck font-medium-5" />
                            <HomeMini status={this.state.fodata.volumeDifference} quantityPrice={this.state.fodata.volumeCurrentMonth + ' L'} Icon="fa fa-credit-card font-medium-5" percentage="-1" description="Shell Card Volume (L)" cssName="avatar p-50 m-0 mb-1 avatar-blue" />
                            <HomeMini status={this.state.fodata.amountDifference} quantityPrice={this.state.fodata.amountCurrentMonth + ' PKR'} Icon="fa fa-money text-warning font-medium-5" percentage="-1" description="Shell Card Spend (PKR)" cssName="avatar bg-rgba-warning p-50 m-0 mb-1" />
                            <HomeMini status={this.state.fodata.travelDistanceDifference} quantityPrice={this.state.fodata.totalTravelsDistanceCurrentMonth + ' KM'} Icon="fa fa-road text-primary font-medium-5" percentage="-1" description="Distance Travelled" cssName="avatar bg-rgba-danger p-50 m-0 mb-1" />
                            <HomeMini status={this.state.fodata.travelTimeDifference} quantityPrice={this.state.fodata.totalTravelsTimeCurrentMonth + ' Hours'} Icon="fa fa-tint text-primary font-medium-5" percentage="-1" description="Total Driven Hours" cssName="avatar bg-rgba-primary p-50 m-0 mb-1" />
                            <HomeMini status={this.state.fodata.avgMileageDifference} quantityPrice={this.state.fodata.avgMileagePerKMCurrentMonth + ' KM'} Icon="fa fa-database text-success font-medium-5" percentage="-1" description="Average Vehicle Shell Card Mileage (KM/L)" cssName="avatar bg-rgba-success p-50 m-0 mb-1" />
                        </CardDeck>

                    </Col>

                    </Row>
                </Container>
            </div>
        );
    }
}

export default FleetOverViewDashboardSummary;
